export default __webpack_public_path__ + "resources/icons/d312-310e.png";